import { z } from 'zod';

/** Mirrors the Admin API validation (AdminLoyaltyRequests.cs); the backend re-checks every rule. */
export const MAX_RULE_POINTS = 100000;
export const MAX_ADJUSTMENT_POINTS = 100000;

const rulePoints = z
  .number({ error: 'Enter a number of points.' })
  .int('Whole points only.')
  .min(0, 'Points cannot be negative.')
  .max(MAX_RULE_POINTS, `At most ${MAX_RULE_POINTS.toLocaleString()} points.`);

export const loyaltyRulesSchema = z.object({
  registrationPoints: rulePoints,
  registrationEnabled: z.boolean(),
  defaultPurchasePoints: rulePoints,
  defaultPurchaseEnabled: z.boolean(),
});

export type LoyaltyRulesFormValues = z.infer<typeof loyaltyRulesSchema>;

export const loyaltyBrandRuleSchema = z.object({
  brandId: z.number().int().positive('Choose a brand.'),
  points: rulePoints,
});

export type LoyaltyBrandRuleFormValues = z.infer<typeof loyaltyBrandRuleSchema>;

export const pointsAdjustmentSchema = z.object({
  direction: z.enum(['add', 'deduct']),
  points: z
    .number({ error: 'Enter a number of points.' })
    .int('Whole points only.')
    .min(1, 'At least 1 point.')
    .max(MAX_ADJUSTMENT_POINTS, `At most ${MAX_ADJUSTMENT_POINTS.toLocaleString()} points.`),
  reason: z
    .string()
    .refine((value) => value.trim().length >= 3, 'Give a reason (3+ characters).')
    .refine((value) => value.trim().length <= 500, 'At most 500 characters.'),
});

export type PointsAdjustmentFormValues = z.infer<typeof pointsAdjustmentSchema>;
